import { Props, VerticalForm } from '@intellihr/ui-components'
import { IHintWrapperProps } from '@intellihr/ui-components/types/domain/Formats/HintWrapper'
import { ITooltipPopoverProps } from '@intellihr/ui-components/types/domain/Popovers'
import { isNil } from 'lodash'
import React, { useContext } from 'react'
import { BaseFieldProps, GenericFieldHTMLAttributes, WrappedFieldProps } from 'redux-form'
import { FormContext } from 'src/services/reduxForm/components/ReduxForm/FormContext'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface IReduxVerticalFormFieldProps<InputProps = { [i: string]: any }> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ComponentType<any>
  label?: string
  description?: string
  isRequired?: boolean
  inputProps?: InputProps
  actionMessage?: JSX.Element
  tooltipMessage?: JSX.Element | string
  tooltipProps?: ITooltipPopoverProps

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any
  margins?: Props.IMargins
  hintOptions?: {
    hint: JSX.Element | string
    label: string
    hintWrapperProps?: Partial<IHintWrapperProps>
  }
  componentContext?: string
}

type IReduxVerticalFormFieldParam = GenericFieldHTMLAttributes | BaseFieldProps<IReduxVerticalFormFieldProps>

const ReduxVerticalFormField: React.FC<WrappedFieldProps & IReduxVerticalFormFieldProps> = ({
  input,
  meta,
  component: InputComponent,
  isRequired = false,
  label,
  inputProps,
  description,
  actionMessage,
  tooltipMessage,
  tooltipProps,
  hintOptions,
  margins,
  componentContext,
}) => {
  const formContext = useContext(FormContext)

  return (
    <VerticalForm.Field
      hintOptions={hintOptions}
      tooltipMessage={tooltipMessage}
      tooltipProps={tooltipProps}
      label={label}
      description={description}
      inputName={input.name}
      actionMessage={actionMessage}
      errorMessages={meta.touched && meta.error}
      isRequired={isRequired}
      componentContext={componentContext}
      margins={margins}
      showLegacyMargin={formContext.showLegacyMargin}
    >
      <InputComponent
        aria-label={label}
        {...input}
        {...inputProps}
        handleBlur={input.onBlur}
        isInvalid={meta.touched && !isNil(meta.error)}
      />
    </VerticalForm.Field>
  )
}

export type { IReduxVerticalFormFieldParam }
export { ReduxVerticalFormField }
